// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsDetailsOptionsStyles } from "@pace/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import IconSearch from "@pace/XDL/Icons/IconSearch";
import IconStepperAdd from "@pace/XDL/Icons/IconStepperAdd";
import IconX from "@pace/XDL/Icons/IconX";
import { color, createLinkIconStyles, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

myListsDetailsOptionsStyles.wrapper = {
    css: css`
        @media print {
            display: none;
        }
        display: flex;
        margin: 20px 0;
        padding: 15px;
        border: 1px solid ${color("common.border")};
    `,
};
myListsDetailsOptionsStyles.leftColumnWrapper = {
    css: css`
        display: flex;
        width: 100%;
        gap: 10px;
        ${xScreen("gt", "md")} {
            align-items: end;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};
myListsDetailsOptionsStyles.container = {
    gap: 20,
};
myListsDetailsOptionsStyles.searchGridItem = { width: [12, 8, 6, 4, 4] };
myListsDetailsOptionsStyles.search = {
    iconProps: {
        src: IconSearch,
        color: "secondary",
    },
};
myListsDetailsOptionsStyles.sortByGridItem = {
    width: [12, 4, 3, 2, 2],
};
myListsDetailsOptionsStyles.selectAllGridItem = {
    width: [12, 8, 6, 3, 3],
    css: css`
        align-items: end;
        ${xScreen("gt", "sm")} {
            padding-bottom: 22px;
        }
    `,
};
myListsDetailsOptionsStyles.selectAllWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    `,
};
myListsDetailsOptionsStyles.addItemsGridItem = {
    width: [12, 4, 6, 3, 3],
    css: css`
        align-items: flex-end;
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            justify-content: flex-start;
        }
    `,
};
myListsDetailsOptionsStyles.addItemsButton = {
    variant: "primary",
    icon: {
        src: IconStepperAdd,
        position: "right",
    },
    css: css`
        align-items: baseline;
        white-space: nowrap;
        padding: 10px 20px;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
        svg path {
            fill: ${color("common.ui1")};
        }
    `,
};
myListsDetailsOptionsStyles.uploadItemsModal = {
    sizeVariant: "large",
};
myListsDetailsOptionsStyles.actionsWrapper = {
    css: css`
        display: inline-flex;
        gap: 10px;
        ${xScreen("lte", "sm")} {
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;
        }
    `,
};
myListsDetailsOptionsStyles.uploadItemsButton = {
    variant: "secondary",
    css: css`
        white-space: nowrap;
        padding-block: 11px;
    `,
};
myListsDetailsOptionsStyles.closeButton = {
    ...createLinkIconStyles(IconX, {
        typographyProps: {
            css: css`
                min-width: 35px;
            `,
        },
        icon: {
            position: "left",
        },
    }),
};
myListsDetailsOptionsStyles.actionButtonsHidden = {
    css: css`
        ${xScreen("lte", "sm")} {
            margin-top: 20px;
        }
    `,
};
myListsDetailsOptionsStyles.productSelectorStyles = {
    container: {
        gap: 10,
        offsetCss: css`
            row-gap: 5px;
        `,
    },
    buttonGridItem: {
        width: [12, 5, 3, 3, 3],
        css: css`
            justify-content: start;
            align-items: flex-start;
            &&&& {
                ${xScreen("lte", "sm")} {
                    align-items: flex-end;
                    max-width: none;
                    flex: 1;
                }
            }
        `,
    },
    selectButton: {
        css: css`
            padding-block: 11px;
            margin: 20px 0 0 0;
            &&&& {
                ${xScreen("lte", "sm")} {
                    margin-top: 0;
                    min-width: 150px;
                }
            }
        `,
    },
    unitOfMeasureGridItem: {
        width: [5, 4, 3, 3, 3],
        css: css`
            &:empty {
                display: none;
            }
            &&& {
                ${xScreen("lte", "sm")} {
                    max-width: none;
                    min-width: 100px;
                    flex: 1;
                }
            }
        `,
    },
    clearIcon: {
        size: 18,
        color: "common.border",
        css: css`
            position: absolute;
            right: 32px;
            top: 35px;
            cursor: pointer;
        `,
    },
};

myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        cursor: pointer;
    `,
};
